"use client";
import { jsx as m, jsxs as r } from "react/jsx-runtime";
import l from "classnames";
import '../../../assets/Form.css';const i = "_form_m5tyk_9", d = "_fieldset_m5tyk_23", _ = "_legend_m5tyk_35", s = {
  form: i,
  fieldset: d,
  "form-footer": "_form-footer_m5tyk_26",
  legend: _,
  "optional-text": "_optional-text_m5tyk_41"
}, N = () => /* @__PURE__ */ m("div", {}), p = ({ title: e, className: o, titleClassName: t = "h4 serif", children: c, optionalText: a, ...f }) => /* @__PURE__ */ r("fieldset", { className: s.fieldset, ...f, children: [
  /* @__PURE__ */ r("legend", { className: l(s.legend, t), children: [
    e,
    !!a && /* @__PURE__ */ r("small", { className: s["optional-text"], children: [
      "— ",
      a
    ] })
  ] }),
  c
] }), y = ({ children: e, className: o, ...t }) => /* @__PURE__ */ m("footer", { className: l(s["form-footer"], o), ...t, children: e }), n = ({ children: e, className: o, ...t }) => /* @__PURE__ */ m("form", { className: l(s.form, o), ...t, children: e });
n.displayName = "Form";
const k = Object.assign(n, { EmptyField: N, Footer: y, Fieldset: p });
export {
  k as default
};
